// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__5oOES","ui-spin":"Spinner_ui-spin__mDt6p","sm":"Spinner_sm__IUvZX","md":"Spinner_md__R9eHQ","lg":"Spinner_lg__yjrTM"};